<template>
  <div>
    <w-datepicker class="form-group" :model="schema.documentValueDates.APPEAL_DATE" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz daty złożenia odwołania
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
